<template>
    <div class="card">
        <div class="card-body">
            <div class="history-title">Withdrawal history</div>
            <div class="mt-4">
                <div class="table-content">
                        <div class="table-responsive ">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Paid to</th>
                                <th scope="col">Account no.</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody  v-for="payment in withdrawStore.history">
                              <tr>
                                <td>{{ payment.created_at }}</td>
                                <td>{{ payment.driver?.first_name }}&nbsp;{{ payment.driver?.middle_name }}&nbsp;{{ payment.driver?.last_name }}</td>
                                <td>{{ payment.account_no  }}</td>
                                <td>{{ payment.paid }}</td>
                                <td :class="payment.status == '1' ? 'text-green' : ''">{{ payment.status == '1' ? 'Successful' : 'Falled' }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useWithdrawStore } from '@/store/driver/withdraw';

const withdrawStore = useWithdrawStore()


onMounted(async () => {
  await withdrawStore.fetchWithdrawHistory()
})
</script>

<style scoped>
.history-title{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;

    color: #051C2C;
}

.table thead th {
  border-bottom: 1px solid #000 !important;
}

.table tbody td {
  border-bottom: 1px solid #fff !important;
}

.text-green{
  color: #00c962;
}
</style>